import { VectorCurveIcon } from './VectorCurveIcon';

/**
 * author: Austin Andrews
 * id 546B7A4F-6D63-46CD-B74D-DEF09CE8D8FB
 * name vector-curve
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-curve.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const BezierIcon = VectorCurveIcon;
export default BezierIcon